import React, {useEffect, useState} from "react";
import {
    Card,
    Row,
    Col,
    Statistic,
    Input,
    Button,
    Table,
    Spin,
    Typography
} from "antd";

import {
    DatabaseOutlined,
    ApartmentOutlined,
    TeamOutlined,
    GlobalOutlined,
    LinkOutlined,
    MailOutlined,
    LinkedinOutlined
} from "@ant-design/icons";

import {toast} from "react-toastify";
import dbQueriesApi from "../../api/databaseConsoleApi";

const {TextArea} = Input;
const {Text} = Typography;

const statCards = [
    {
        key: "leadProspectCount",
        title: "Lead Prospect",
        icon: <DatabaseOutlined/>
    },
    {
        key: "employeeStatsCount",
        title: "Employee Stats",
        icon: <TeamOutlined/>
    },
    {
        key: "companyStatsCount",
        title: "Company Stats",
        icon: <ApartmentOutlined/>
    },
    {
        key: "duplicateEmails",
        title: "Duplicate Emails",
        icon: <MailOutlined/>
    },
    {
        key: "duplicateCompanies",
        title: "Duplicate Companies",
        icon: <ApartmentOutlined/>
    },
    {
        key: "distinctCountries",
        title: "Distinct Countries",
        icon: <GlobalOutlined/>
    },
    {
        key: "distinctIndustries",
        title: "Distinct Industries",
        icon: <DatabaseOutlined/>
    },
    {
        key: "distinctDomains",
        title: "Distinct Domains",
        icon: <LinkOutlined/>
    },
    {
        key: "companiesWithWebsite",
        title: "Companies With Website",
        icon: <LinkOutlined/>
    },
    {
        key: "companiesWithoutWebsite",
        title: "Companies Without Website",
        icon: <LinkOutlined/>
    },
    {
        key: "contactsWithLinkedIn",
        title: "Contacts With LinkedIn",
        icon: <LinkedinOutlined/>
    },
    {
        key: "contactsWithoutLinkedIn",
        title: "Contacts Without LinkedIn",
        icon: <LinkedinOutlined/>
    },
    {
        key: "contactsWithEmail",
        title: "Contacts With Email",
        icon: <MailOutlined/>
    },
    {
        key: "contactsWithoutEmail",
        title: "Contacts Without Email",
        icon: <MailOutlined/>
    }
];

export default function DatabaseConsolePage() {

    const [loading, setLoading] = useState(false);
    const [stats, setStats] = useState({});
    const [query, setQuery] = useState("");

    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [executionTime, setExecutionTime] = useState(0);

    useEffect(() => {
        loadStats();
    }, []);

    const loadStats = async () => {

        setLoading(true);

        const res = await dbQueriesApi.getStats();

        if (res.success) {
            setStats(res.data.data);
        } else {
            toast.error("Unable to load statistics");
        }

        setLoading(false);
    };

    const execute = async () => {

        if (!query.trim()) {
            toast.warning("Please enter SQL query");
            return;
        }

        setLoading(true);

        const res = await dbQueriesApi.executeQuery(query);

        if (res.success) {

            const result = res.data.data;

            setExecutionTime(result.executionTime);

            setColumns(
                result.columns.map(col => ({
                    title: col,
                    dataIndex: col,
                    key: col
                }))
            );

            setRows(
                result.rows.map((r, index) => ({
                    key: index,
                    ...r
                }))
            );

        } else {
            toast.error("Query execution failed");
        }

        setLoading(false);
    };

    return (
        <Spin spinning={loading}>

            {/* Statistics */}

            <Row gutter={[16, 16]}>

                {statCards
                    .filter(card => (stats?.[card.key] ?? 0) > 0)
                    .map(card => (
                        <Col
                            xs={24}
                            sm={12}
                            md={8}
                            lg={6}
                            xl={6}
                            key={card.key}
                        >
                            <Card hoverable>
                                <Statistic
                                    title={card.title}
                                    value={stats?.[card.key] ?? 0}
                                    prefix={card.icon}
                                />
                            </Card>
                        </Col>
                    ))}

            </Row>

            <Card
                title="Execute SQL Query"
                style={{marginTop: 20}}
            >

                <TextArea
                    rows={8}
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="SELECT count(*) FROM tbl_base_data"
                />

                <Button
                    type="primary"
                    style={{marginTop: 15}}
                    onClick={execute}
                >
                    Execute Queries
                </Button>

                <div style={{marginTop: 10}}>
                    <Text>
                        Execution Time : {executionTime} ms
                    </Text>
                </div>

            </Card>

            <Card
                title={`Result (${rows.length} Rows)`}
                style={{marginTop: 20}}
            >

                <Table
                    bordered
                    scroll={{x: true}}
                    columns={columns}
                    dataSource={rows}
                    pagination={{
                        pageSize: 5,
                        showSizeChanger: true,
                     }}
                />

            </Card>

        </Spin>
    );

}